import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import {connect}  from  "react-redux";
import axios from "axios";
import { useLocation } from 'react-router-dom'
import {BeatLoader} from 'react-spinners';
import {css} from "@emotion/core";
import { user_activities } from '../helpers/utils.js';
import ModalD from "react-awesome-modal";
import DatePicker from "react-datepicker";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
const { tableau } = window;
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    color: white;
    text-align:center;
`;
const d = new Date();
var year = d.getFullYear();
var month = d.getMonth();
var day = d.getDate();
function convertToCSV(json) { console.log("ggggggggg"); console.log(json);
      const items = json;
      const replacer = (key, value) => (value === null ? '' : value); // Replace null values with empty strings
      const header = Object.keys(items[0]);
      const csv = [
        header.join(','), // Create CSV header row
        ...items.map((row) => header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(',')), // Create CSV data rows
      ].join('\r\n');

      return csv;
    }

    function downloadCSV(csv, filename) {
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) {
        // For IE and Edge
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }
    const extractKeyValue = (array, ...keysToExtract) => {
      return array.map((obj) => {
        const extractedData = {};
        keysToExtract.forEach((key) => {
          extractedData[key] = obj[key];
        });
        return extractedData;
      });
    };
class LoungeReport1 extends Component{
    constructor(props) {
        super(props);
        this.state = {
            reportPermissionsArray:[],
            tableau_worksheet:[],
            project_name:"",
            loading: true,
            showForm:false,
            isMsg:false,
            underlyingData: [],
            startDate: new Date(),
            endDate: new Date(year, month + 3, day),
            _notificationSystem: null,
            visitType:"",
            no_of_visits:"",
            campaign_data:[],
            visit_count:"",
            customers_count:"",
            selectedMarks: [],
            filterInfo:{},
            marksData: {},
            selectedMarksData: {},
            isVizConnected: '',

        }
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentWillMount() {
        this.props.currentMenu("unipaynext");
    }

    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log(decoded);

        this.get_trusted_token(decoded.tableau_username);
        this.checkConnectionInterval = setInterval(this.checkConnectionStatus, 300000);
//         user_activities(1, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email)

    }
     componentWillUnmount() {
    // Clean up when component is unmounted
    clearInterval(this.checkConnectionInterval);
  }

  checkConnectionStatus = () => {
  var keyValuesData = [];
    if (this.viz) {
         var sheet = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Visit-Organization");
	       // If the active sheet is not a dashboard, then you can just enter:
	       // viz.getWorkbook().getActiveSheet();
         var options = {
            maxRows: 0, // Max rows to return. Use 0 to return all rows
            ignoreAliases: true,
            ignoreSelection: false,
            includeAllColumns: false
          };
          console.log(sheet);
          if(sheet) {
             console.log("find the sheet")
          }
          else {
              console.log("worksheet data null")
          }
           console.log("bbbbbbbbbbbbb");
          sheet.getUnderlyingDataAsync(options).then(function(t){
              console.log("uuuuuuuuuuuuuuu");

//                   const csv = convertToCSV(keyValuesData);
//                   const filename = 'lounge-report.csv';
//                   downloadCSV(csv, filename);

              });

    }
//    const sheet1 = this.viz.getWorkbook().getActiveSheet();
//    console.log(sheet1);
//    if(sheet1){
//     console.log("connected");
//     console.log(new Date().toLocaleString())
//    } else {
//      console.log("connection lost");
//      console.log(new Date().toLocaleString())
//    }
//    if (this.viz) {
//         console.log("connected viz");
//    }
//    else {
//         console.log("connection lost viz");
//    }
  };


    get_trusted_token(tableau_username){
        if(tableau_username==='' || tableau_username===null || tableau_username==='null'){
            alert("Your account is not mapped with tableau user.");
            this.setState({
               loading:false,
            });
            return false;
        }

        axios.get(config.get('API_URL')+'/tableau/get-trusted-token/',

       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                tableau_username: tableau_username,
            }
        }).then(response => {
            //console.log(response.data);

            if(response.data.data!== undefined) {
                this.get_tableau_report(this.props.match.params.id);

                this.setState({
                    tableau_token:response.data.data,
                    tableau_server_url: response.data.server_url,
                    token_error:false,
                    loading:false,
                });
            } else {
                alert("Error while generating token");
                //this.get_tableau_report(this.props.match.params.id);
                //console.log("dddddddd", response.data.error.error)
                this.setState({
                    token_error:true,
                    loading:false,
                    tableau_token:response.data.data,
                    tableau_server_url: response.data.server_url

                });
            }


        }).catch(error => {
          console.log(error);
        });
    }
    get_tableau_report(view_id){
         axios.post(config.get('API_URL')+'/tableau/get-tableau-report/',
         {
            view_id:view_id
         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            this.setState({
                tableau_report_name: response.data.view_name,
                tableau_report_link: response.data.url,
                workbook_name: response.data.project_name,
                workbook_kpi_id: response.data.project_id,
                worksheet_name: response.data.workbook_name,
                worksheet_kpi_id: response.data.workbook_id,
            })

            this.initTableauViz()

        }).catch( err => {
            console.log(err);
        });
    }
    initTableauViz = () => {
    let reportUrl = this.state.tableau_server_url+"/trusted/"+this.state.tableau_token+this.state.tableau_report_link
    const vizDiv = document.getElementById('tableauViz');
    const vizURL = reportUrl;

    const options = {
      width: '100%',
      height: '600px',
      hideTabs: false,
      hideToolbar: true,
      onFirstInteractive: this.handleFirstInteractive,
    };

    // Create a new Tableau Viz object
    const viz = new tableau.Viz(vizDiv, vizURL, options);
    this.viz = viz;
  };

  getUnderlyingData(e) {
    var that = this;
    // Call the getUnderlyingDataAsync method on the viz object
    var keyValuesData = [];
    if (this.viz) {
         var sheet = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Visit-Organization");
	       // If the active sheet is not a dashboard, then you can just enter:
	       // viz.getWorkbook().getActiveSheet();
         var options = {
            maxRows: 0, // Max rows to return. Use 0 to return all rows
            ignoreAliases: true,
            ignoreSelection: false,
            includeAllColumns: false
          };
          console.log(sheet);
          if(sheet) {
             console.log("find the sheet")
          }
          else {
              console.log("worksheet data null")
          }
           console.log("bbbbbbbbbbbbb");
          sheet.getSummaryDataAsync(options).then(function(t){
              console.log("uuuuuuuuuuuuuuu");
              var columns = t.getColumns();
              var dataRows = t.getData();
              console.log(columns);
              //console.log(dataRows);
                 for (var i = 0; i < dataRows.length; i++) {
                      var row = dataRows[i];
                      var keyValueRow = {};

                      for (var j = 0; j < columns.length; j++) {
                        var fieldName = columns[j].getFieldName();
                        var fieldValue = row[j].value;

                        keyValueRow[fieldName] = fieldValue;
                      }

                      keyValuesData.push(keyValueRow);
                    }
                  console.log("summaryyyy")
                  console.log(keyValuesData);
                  const csv = convertToCSV(keyValuesData);
                  const filename = 'lounge-report.csv';
                  downloadCSV(csv, filename);
                  that.setState({
                    underlyingData:keyValuesData
                  })
              });

    }
  }
  closeUploadModal(){
    this.setState({
        user_upload: false,
        showForm:false,
        isMsg:false,
        startDate: new Date(),
        endDate: new Date(year, month + 3, day),
        visitType:"",
        no_of_visits:""
    })
  }
   toggleNewUserUpload(e){
        this.setState({
            user_upload: true
        })
        var that = this;
    // Call the getUnderlyingDataAsync method on the viz object
    var keyValuesData = [];
    var keyValuesData1 = [];
    if (this.viz) {
         var sheet = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Visit-Organization");
	       // If the active sheet is not a dashboard, then you can just enter:
	       // viz.getWorkbook().getActiveSheet();
         var options = {
            maxRows: 0, // Max rows to return. Use 0 to return all rows
            ignoreAliases: true,
            ignoreSelection: false,
            includeAllColumns: false
          };
          console.log(sheet);
          if(sheet) {
             console.log("find the sheet")
          }
          else {
              console.log("worksheet data null")
          }
          sheet.getUnderlyingDataAsync(options).then(function(t){
              var columns = t.getColumns();
              var dataRows = t.getData();
              console.log(columns);
              //console.log(dataRows);
                 for (var i = 0; i < dataRows.length; i++) {
                      var row = dataRows[i];
                      var keyValueRow = {};

                      for (var j = 0; j < columns.length; j++) {
                        var fieldName = columns[j].getFieldName();
                        var fieldValue = row[j].value;

                        keyValueRow[fieldName] = fieldValue;
                      }

                      keyValuesData.push(keyValueRow);
                    }

                  const extractedDataArray = extractKeyValue(keyValuesData, "Mobile Hash");
                  console.log(extractedDataArray);
                  that.setState({
                    underlyingData:keyValuesData,
                    campaign_data: extractedDataArray
                  })
              });

              //customers

               var sheet1 = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Customers");
	       // If the active sheet is not a dashboard, then you can just enter:
	       // viz.getWorkbook().getActiveSheet();
         var options1 = {
            maxRows: 0, // Max rows to return. Use 0 to return all rows
            ignoreAliases: true,
            ignoreSelection: false,
            includeAllColumns: false
          };
          console.log(sheet1);
          if(sheet1) {
             console.log("find the sheet")
          }
          else {
              console.log("worksheet data null")
          }
          sheet1.getUnderlyingDataAsync(options1).then(function(t){
              var columns1 = t.getColumns();
              var dataRows1 = t.getData();
			  console.log(dataRows1.length);
			  var customers_count = dataRows1.length
              console.log(columns1);
              for (var i1 = 0; i1 < dataRows1.length; i1++) {
                      var row1 = dataRows1[i1];
                      var keyValueRow1 = {};

                      for (var j1 = 0; j1 < columns1.length; j1++) {
                        var fieldName1 = columns1[j1].getFieldName();
                        var fieldValue1 = row1[j1].value;

                        keyValueRow1[fieldName1] = fieldValue1;
                      }

                      keyValuesData1.push(keyValueRow1);
                    }
                    var lookup = {};
                    var items = keyValuesData1;
                    var result = [];

                    for (var item, i = 0; item = items[i++];) {
                      var name = item["Member Id"];

                      if (!(name in lookup)) {
                        lookup[name] = 1;
                        result.push(name);
                      }
                    }
                    console.log(result);
                  that.setState({
                    customers_count:result.length
                  })
              });

              //customers

               var sheet2 = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Visits");
	       // If the active sheet is not a dashboard, then you can just enter:
	       // viz.getWorkbook().getActiveSheet();
         var options2 = {
            maxRows: 0, // Max rows to return. Use 0 to return all rows
            ignoreAliases: true,
            ignoreSelection: false,
            includeAllColumns: false
          };
          console.log(sheet2);
          if(sheet2) {
             console.log("find the sheet")
          }
          else {
              console.log("worksheet data null")
          }
          sheet2.getUnderlyingDataAsync(options2).then(function(t){
              var columns2 = t.getColumns();
              var dataRows2 = t.getData();
			  console.log(dataRows2.length);
			  var visit_count = dataRows2.length
              console.log(columns2);
              //console.log(dataRows1);
                  that.setState({
                    visit_count:visit_count
                  })
              });
    }
    }
    changeVal=event=>{

    };
    ChangeEligibility(e) {
        this.setState({
            showForm: !this.state.showForm,
        })
    }
    importData(e) {
        var startDate = this.state.startDate;
        var endDate = this.state.endDate;
        var today = new Date();
        today.setHours(0,0,0,0);

        if (startDate=="") {
          this.handleNotificationClick("tr", 3, "Please Select Eligible From");
          return false;
        }
        if (endDate=="") {
          this.handleNotificationClick("tr", 3, "Please Select Eligible To");
          return false;
        }
        if ((Date.parse(startDate) < Date.parse(today))) {
          this.handleNotificationClick("tr", 3, "Eligible From should be greater than or equal to today");
          return false;
        }
        if ((Date.parse(endDate) <= Date.parse(startDate))) {
          this.handleNotificationClick("tr", 3, "Eligible To should be greater than Eligible From");
          return false;
        }
        if (this.state.visitType=="") {
          this.handleNotificationClick("tr", 3, "Please select Visit Type");
          return false;
        }
        if (this.state.no_of_visits=="") {
          this.handleNotificationClick("tr", 3, "Please enter No of Visits");
          return false;
        }

        this.setState({
            isMsg: true,
        })
    }
    handleFromChange = date => {
        // var aa = date.format('yyyy-MM-dd');

        this.setState({
            startDate: date
        });
    };

    handleToChange = date => {
        this.setState({
            endDate: date
        });
    };
    changeVisitType(e){
        this.setState({
            visitType:e.target.value
        })
    }
    changeNoOfVisit(e){
        this.setState({
            no_of_visits:e.target.value
        })
    }
    download_campaign(e) {
        const csv1 = convertToCSV(this.state.campaign_data);
        const filename1 = 'marketing_communication.csv';
        downloadCSV(csv1, filename1);
    }

//      handleMarksSelection = (event) => {
//      console.log("sheet Name");
//      var sheetName = event.getWorksheet().getName();
//      console.log(sheetName);
//     const selectedMarks = event.getMarksAsync().then((marks) => {
//       console.log("marks")
//       console.log(marks)
//       this.setState({
//         selectedMarks: marks,
//       });
//     });
//     const filterInfo = {};
//
//     tableau.VizManager.getVizs().forEach((viz) => {
//       const worksheet = viz.getWorkbook().getActiveSheet();
//       const filters = worksheet.getFiltersAsync().then((worksheetFilters) => {
//         filterInfo[worksheet.getName()] = worksheetFilters;
//         console.log(filterInfo);
//
//         this.setState({
//           filterInfo: filterInfo,
//         });
//       });
//     });
//   };

handleFirstInteractive = () => {
    this.viz.addEventListener(
      tableau.TableauEventName.MARKS_SELECTION,
      this.handleMarksSelection
    );
//      this.viz.addEventListener(
//       tableau.TableauEventName.VIZ_RESIZE,
//       this.handleVizResize
//     );

//     this.viz.addEventListener(
//       tableau.TableauEventName.VIZ_LOST_FOCUS,
//       this.handleVizLostFocus
//     );

//     this.viz.addEventListener(
//       tableau.TableauEventName.VIZ_GAIN_FOCUS,
//       this.handleVizGainFocus
//     );
  };
//     handleVizResize = () => {
//     // Handle viz resize if needed
//   };

  handleVizLostFocus = (event) => {
  console.log(event);
  alert("hiiiiiiiiiii")
    this.setState({
      isVizConnected: false,
    });
  };

//   handleVizGainFocus = () => {
//     this.setState({
//       isVizConnected: true,
//     });
//   };
  handleMarksSelection = (event) => {
    const worksheetName = event.getWorksheet().getName();
    const selectedMarks = event.getMarksAsync().then((marksArray) => {
      this.setState((prevState) => ({
        selectedMarksData: {
          ...prevState.selectedMarksData,
          [worksheetName]: marksArray,
        },
      }));
    });
  };

  generateSelectedMarksText = () => {
    const { selectedMarksData } = this.state;
    let allSelectedMarksText = '';

    for (const [sheetName, marksArray] of Object.entries(selectedMarksData)) {
      //allSelectedMarksText += `${sheetName}:\n`;
      console.log(marksArray.length);
      if(marksArray.length > 0) {
        var marksDataArray = marksArray[0].getPairs();
        console.log(marksDataArray);
        if(sheetName=='Source-Destination'){
            marksDataArray = [...marksDataArray].reverse();
           // marksDataArray.splice(2, 1);
        }
//         if(sheetName=='Pareto'){
//             var marksDataArray1 = marksArray[0].getPairs();
//             marksDataArray = marksDataArray1.splice(0, 1);
//         }
//         if(sheetName=='Organization Trend'){
//             var marksDataArray2 = marksArray[0].getPairs();
//             marksDataArray = marksDataArray2.splice(0, 1);
//         }
        if(sheetName=='Visits Trend'){
             marksDataArray = [...marksDataArray].reverse();
            //marksDataArray = marksDataArray3.splice(0, 1);
        }

        marksDataArray.map((pair, colIndex) => {
        if(pair.fieldName == 'Source' || pair.fieldName == 'Destination' || pair.fieldName == 'lounge_name' || pair.fieldName == 'Name (Member Organizations)' || pair.fieldName == 'Name (Member Organizations)' || pair.fieldName == 'Measure Names' || pair.fieldName == 'MONTH(Created At)') {
            allSelectedMarksText += `${this.replaceFieldName(pair.fieldName)}: ${pair.formattedValue}, `;
          }
        })
      }


      allSelectedMarksText += '\n';
    }

    return allSelectedMarksText;
  };
  replaceFieldName = (originalFieldName) => {
    // Replace field names with custom names as needed
    if (originalFieldName === 'lounge_name') {
      return 'Lounge name';
    } else if (originalFieldName === 'Name (Member Organizations)') {
      return 'Organization';
      }
      else if (originalFieldName === 'Measure Names') {
      return 'Visit Type';
      }
      else if (originalFieldName === 'MONTH(Created At)') {
      return 'Month';
      }

    // Return the original field name if not replaced
    return originalFieldName;
  };

//   renderMarksTable = (worksheetName, marksArray) => {
//     return (
//       <div key={worksheetName}>
//         <h3>{worksheetName}</h3>
//         <table border="1">
//           <thead>
//             <tr>
//               {marksArray.length > 0 &&
//                 marksArray[0].getPairs().map((pair, colIndex) => (
//                   <th key={colIndex}>{pair.fieldName}</th>
//                 ))}
//             </tr>
//           </thead>
//           <tbody>
//             {marksArray.map((mark, index) => (
//               <tr key={index}>
//                 {Object.values(mark.getPairs()).map((value, colIndex) => (
//                   <td key={colIndex}>{value.value}</td>
//                 ))}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     );
//   };

    render() {
    const allSelectedMarksText = this.generateSelectedMarksText();
    const { selectedMarksData } = this.state;
    const sheetNames = Object.keys(selectedMarksData);
    console.log(sheetNames);
        console.log("underlyingData state")
        console.log("isVizConnected");
        console.log(this.state.isVizConnected);
        console.log(this.state.underlyingData);
        var stdate = this.state.startDate;
        var stadate = stdate.toISOString().split('T')[0];
        console.log(stadate);
        var endate = this.state.endDate;
        var enddate = endate.toISOString().split('T')[0];
        console.log(stadate);
        let cardLists = this.state.underlyingData.map((underlying_data, index) => {
            var nm = "";
            if(underlying_data["Mobile Number"]!=""){
                const firstDigit = underlying_data["Mobile Number"].charAt(0);
                const secDigit = underlying_data["Mobile Number"].charAt(1);
                nm = firstDigit+secDigit+"xxxx"+underlying_data["Mobile Number"].substr(-4);
            }
            return (
                <li key={index + 1}>{nm}</li>
            )
        });
        let workbookUrl = "/admin/lounge-workbook/"+this.state.workbook_kpi_id;
        let worksheetUrl = "/admin/lounge-view/"+this.state.worksheet_kpi_id;
        let reportUrl = this.state.tableau_server_url+"/trusted/"+this.state.tableau_token+this.state.tableau_report_link+"?:embed=yes";
        return(
            <div className="content-invoice">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="card title-card-bottom-space">
                                            <nav aria-label="breadcrumb">
                                                    <ol className="breadcrumb">
                                                        <li className="breadcrumb-item">
                                                            <Link className="" to="/admin/lounge-project/" >Project</Link>
                                                        </li>
                                                        <li class="breadcrumb-item">
                                                            <Link className="" to={workbookUrl} >{this.state.workbook_name}</Link>
                                                        </li>
                                                        <li class="breadcrumb-item">
                                                            <Link className="" to={worksheetUrl} >{this.state.worksheet_name}</Link>
                                                        </li>

                                                        <li aria-current="page" class="breadcrumb-item active">{this.state.tableau_report_name}</li>
                                                        <div className="col-md-3 pull-right">
                                                            <button type="button" className="btn btn-primary" role="button" onClick={this.getUnderlyingData.bind(this)}>
                                                                <i className="fa fa-download" aria-hidden="true"></i>&nbsp;Export
                                                            </button> &nbsp;&nbsp;
                                                            <button type="button" className="btn btn-primary" role="button" onClick={this.toggleNewUserUpload.bind(this, 'Add')}>
                                                                Action Console
                                                            </button>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </ol>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="header">*/}
                                {/*    <h4 className="title">Transaction</h4>*/}
                                {/*    <p className="category"></p>*/}
                                {/*</div>*/}
                                <div className="row">
                                  <BeatLoader
                                      css={override}
                                      sizeUnit={"px"}
                                      size={15}
                                      color={'#123abc'}
                                      loading={this.state.loading}
                                  />
                                    <div className="col-md-12 tableauEmbed">
                                    {this.state.loading===false && this.state.token_error===false?
                                         <div id="tableauViz"></div>:null}
                                    </div>




{/*                                     <div> */}
{/*           <h2>Selected Marks</h2> */}
{/*           <table> */}
{/*             <thead> */}
{/*               <tr> */}
{/*                 <th>Field 1</th> */}
{/*                 <th>Field 2</th> */}
{/*                  */}{/* Add more table headers for each field in your data */}
{/*               </tr> */}
{/*             </thead> */}
{/*             <tbody> */}
{/*               {this.state.selectedMarks.map((mark, index) => ( */}
{/*                 <tr key={index}> */}
{/*                   <td>{mark.getPairs()[0].value}</td> */}
{/*                   <td>{mark.getPairs()[1].value}</td> */}
{/*                    */}{/* Add more table cells for each field in your data */}
{/*                 </tr> */}
{/*               ))} */}
{/*             </tbody> */}
{/*           </table> */}
{/*         </div> */}
{/*         {this.state.filterInfo? */}
{/*         <div> */}
{/*           <h2>Filter Information</h2> */}
{/*           {Object.keys(this.state.filterInfo).map((worksheetName) => ( */}
{/*             <div key={worksheetName}> */}
{/*               <h3>{worksheetName}</h3> */}
{/*               <ul> */}
{/*                 {this.state.filterInfo[worksheetName].map((filter, index) => ( */}

{/*                   <li key={index}>{filter.getAppliedValues()}</li> */}
{/*                 ))} */}
{/*               </ul> */}
{/*             </div> */}
{/*           ))} */}
{/*         </div>: null } */}
                                </div>
                                <div className="col-md-12 userModelBox">
                                   <ModalD visible={this.state.user_upload} width="75%" height="100%" effect="fadeInUp">
                                      <div className="">
                                         <div className="">
                                            <div className="modal-header">
                                               <div className="col-md-6"> Action Console</div>
                                               <div className="col-md-1 pull-right">
                                                  <a href="javascript:void(0);" onClick={() => this.closeUploadModal()}>
                                                  <i className="fa fa-times-circle" aria-hidden="true"></i>
                                                  </a>
                                               </div>
                                               <div className="clearfix"></div>
                                            </div>
                                         </div>
                                         <div className="">
                                            <div className="col-md-3 card-con">
                                               <h6>List of Mobile Numbers</h6>
                                               <div className="cardLists">
                                                  <ul>{cardLists}
{/*                                                      <li>3426xxxxxxxx2414</li> */}
{/*                                                      <li>4322xxxxxxxx0185</li> */}
{/*                                                      <li>3857xxxxxxxx8053</li> */}
{/*                                                      <li>9496xxxxxxxx9320</li> */}
{/*                                                      <li>6993xxxxxxxx4903</li> */}
{/*                                                      <li>1751xxxxxxxx8268</li> */}
{/*                                                      <li>8363xxxxxxxx1464</li> */}
{/*                                                      <li>1900xxxxxxxx9989</li> */}
{/*                                                      <li>6669xxxxxxxx7812</li> */}
{/*                                                      <li>8925xxxxxxxx5191</li> */}
{/*                                                      <li>1463xxxxxxxx6763</li> */}
{/*                                                      <li>7261xxxxxxxx3358</li> */}
{/*                                                      <li>1162xxxxxxxx2137</li> */}
{/*                                                      <li>4226xxxxxxxx8690</li> */}
{/*                                                      <li>9244xxxxxxxx5908</li> */}
{/*                                                      <li>6120xxxxxxxx6235</li> */}
{/*                                                      <li>8131xxxxxxxx5603</li> */}
{/*                                                      <li>5376xxxxxxxx0563</li> */}
{/*                                                      <li>4842xxxxxxxx8524</li> */}
{/*                                                      <li>5240xxxxxxxx7823</li> */}
{/*                                                      <li>1331xxxxxxxx6701</li> */}
{/*                                                      <li>1357xxxxxxxx4251</li> */}
{/*                                                      <li>3261xxxxxxxx5673</li> */}
{/*                                                      <li>9524xxxxxxxx2668</li> */}
{/*                                                      <li>3354xxxxxxxx0414</li> */}
{/*                                                      <li>3297xxxxxxxx8593</li> */}
{/*                                                      <li>5612xxxxxxxx9874</li> */}
{/*                                                      <li>3952xxxxxxxx3580</li> */}
{/*                                                      <li>8126xxxxxxxx5798</li> */}
{/*                                                      <li>2417xxxxxxxx6678</li> */}
{/*                                                      <li>2300xxxxxxxx6978</li> */}
{/*                                                      <li>5949xxxxxxxx7439</li> */}
{/*                                                      <li>1739xxxxxxxx5555</li> */}
{/*                                                      <li>8403xxxxxxxx7364</li> */}
{/*                                                      <li>3985xxxxxxxx9160</li> */}
{/*                                                      <li>1455xxxxxxxx9938</li> */}
{/*                                                      <li>7920xxxxxxxx5685</li> */}
{/*                                                      <li>5614xxxxxxxx0924</li> */}
{/*                                                      <li>2572xxxxxxxx6043</li> */}
{/*                                                      <li>3065xxxxxxxx8747</li> */}
{/*                                                      <li>6295xxxxxxxx9841</li> */}
{/*                                                      <li>4759xxxxxxxx3898</li> */}
{/*                                                      <li>2796xxxxxxxx8354</li> */}
{/*                                                      <li>7450xxxxxxxx5270</li> */}
{/*                                                      <li>3774xxxxxxxx0149</li> */}
{/*                                                      <li>1123xxxxxxxx6777</li> */}
{/*                                                      <li>5349xxxxxxxx1916</li> */}
{/*                                                      <li>3217xxxxxxxx8796</li> */}
{/*                                                      <li>3900xxxxxxxx1634</li> */}
{/*                                                      <li>6472xxxxxxxx6165</li> */}
{/*                                                      <li>2651xxxxxxxx0930</li> */}
{/*                                                      <li>2750xxxxxxxx7978</li> */}
{/*                                                      <li>1429xxxxxxxx9417</li> */}
{/*                                                      <li>5701xxxxxxxx0074</li> */}
                                                  </ul>
                                               </div>
                                            </div>
                                            <div className="col-sm-9 action-console">
                                               <div className="col-md-12">
                                                  <h6>Filter Applied</h6>
                                                  <p>{allSelectedMarksText} {this.state.customers_count} customers have been selected</p>
                                                  <button type="button" className="btn btn-primary" role="button"  onClick={this.ChangeEligibility.bind(this)}>Change Eligibility</button>
                                               {this.state.showForm===true?   <hr/>: null }
                                               </div>
                                               {this.state.showForm===true?
                                               <div>
                                               <div className="col-md-6 ">
                                                  <div className="form-group">
                                                     <label htmlFor="queryName" className="">Eligible From</label>
                                                        <DatePicker
                                                            dateFormat="d MMM yyyy"
                                                            selected={Date.parse(this.state.startDate)}
                                                            onChange={this.handleFromChange}
                                                        />
{/*                                                      <input  value= "31 Jul 2023" placeholder= "31 Jul 2023" type="text" name="file" className="form-control" onChange={this.changeVal} /> */}
                                                  </div>
                                               </div>
                                               <div className="col-md-6 ">
                                                  <div className="form-group">
                                                     <label htmlFor="queryName" className="">Eligible To</label>
                                                         <DatePicker
                                                            dateFormat="d MMM yyyy"
                                                            selected={Date.parse(this.state.endDate)}
                                                            onChange={this.handleToChange}
                                                        />
{/*                                                      <input value= "31 Sep 2023" placeholder= "31 Sep 2023" type="text" name="fileDoc" className="form-control" onChange={this.changeVal} /> */}
                                                  </div>
                                               </div>
                                               <div className="col-md-6 ">
                                                  <div className="form-group">
                                                     <label htmlFor="queryName" className="">Visit Type</label>
                                                     <select name="visitType" className="form-control"
                                                        value={this.state.visitType}
                                                        onChange={this.changeVisitType.bind(this)}
                                                        >
                                                        <option value="">Select Visit Type</option>
                                                        <option value="Additional Visits">Additional Visits</option>
                                                        <option value="Reward Redemption">Reward Redemption</option>
                                                        <option value="Complementary Visits">Complementary Visits</option>
                                                     </select>
                                                  </div>
                                               </div>
                                               <div className="col-md-6 ">
                                                  <div className="form-group">
                                                     <label htmlFor="queryName" className="">No of Visits</label>
                                                     <input type="text" value= {this.state.no_of_visits} placeholder= "7" name="no_of_visits" className="form-control" onChange={this.changeNoOfVisit.bind(this)} />
                                                  </div>
                                               </div>
                                               <div className="col-md-6 ">
                                                  <button type="button" className="btn btn-primary" role="button"  onClick={this.importData.bind(this)}>Submit</button>
                                               </div>
                                               <div className="clearfix"></div>
                                               </div>:null}

                                              {this.state.isMsg===true?
                                               <div className="col-md-12 success-msg-lo">
                                                  <hr/>
                                                  <p>The following lounge visit eligibility changes have been made to the selected member profiles:</p>
                                                  <div className="msg-table">
                                                     <table border = "1">
                                                        <thead>
                                                        <tr>
                                                           <th># Members</th>
                                                           <th>Eligible from</th>
                                                           <th>Eligible to</th>
                                                           <th>Visit Type</th>
                                                           <th>No of Visits</th>
                                                           <th>Status</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                           <td>{this.state.customers_count}</td>
                                                           <td>{stadate}</td>
                                                           <td>{enddate}</td>
                                                           <td>{this.state.visitType}</td>
                                                           <td>{this.state.no_of_visits}</td>
                                                           <td>Success <i class="fa fa-check-circle" aria-hidden="true"></i></td>
                                                        </tr>
                                                        </tbody>
                                                     </table>
                                                  </div>
                                                  <br/>
                                                  {/*
                                                  <div><label><b>Eligible from:</b> 31 Jul 2023</label> </div>
                                                  */}
                                                  {/*
                                                  <div><label><b>Eligible to:</b> 31 Sep 2023</label> </div>
                                                  */}
                                                  {/*
                                                  <div><label> <b>Visit Type:</b> Additional Visits</label> </div>
                                                  */}
                                                  {/*
                                                  <div><label> <b>No of Visits:</b> 7 </label> </div>
                                                  */}
                                                  <div className="download-m-file"><a href="#" onClick={this.download_campaign.bind(this)}>Download Marketing Communication File</a></div>
                                               </div>:null}
                                            </div>
                                            <div className="clearfix"></div>
                                         </div>
                                      </div>
                                   </ModalD>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(LoungeReport1);